<template>
    <div class="modal fade" :id="'vmbc'+ product.id" role="dialog">
        <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{product.name}}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <input type="text" class="form-control mt-1" v-model="product.name" placeholder="xero">

                <model-select :options="categories"
                    v-model="product.catID"
                    placeholder="Please select categories">
                </model-select>

                <input type="text" class="form-control mt-1" v-model="product.xero" placeholder="xero">
                <textarea v-model="product.description" rows="5" class="form-control mt-1" placeholder="Description"></textarea>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="updateProduct(product)"><i class="fa fa-save"></i></button>
                <button type="button" class="btn btn-default" data-dismiss="modal"><i class="fa fa-times"></i></button>
            </div>
        </div>

        </div>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
      components: {
        ModelSelect
    },
    props: ['product', 'categories',],
    methods: {

        updateProduct(product){
            axios.post('./api/Product/Update', {
                    id: product.id,
                    name: product.name,
                    xero: product.xero,
                    category: product.catID,
                    description: product.description,
                    user_id: this.$root.id,
                    name_user: this.$root.staffname,
                })
                .then(function (response) {
                    console.log(response);
                    $('.modal').modal('hide');

                })
                .catch(function (error) {
                    console.log(error);
                });
        }

    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Item/Product/ProductEdit.vue